(() => {
  if (customElements.get('amelia-cart-recommendations')) return;
  class AmeliaCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-amcart-track]');
      this.fallback = this.track.innerHTML;
      this.cache = new Map();
      this.onChange = () => this.refresh();
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = {id:event.pointerId,x:event.clientX,left:this.track.scrollLeft,moved:false};
      },options);
      this.track.addEventListener('pointermove',event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const distance = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(distance) < 6) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
        }
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - distance;
      },options);
      const endDrag = event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        this.wasDragged = this.drag.moved;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if(this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        clearTimeout(this.dragTimer);
        this.dragTimer = setTimeout(()=>{this.wasDragged=false;},0);
      };
      this.track.addEventListener('pointerup',endDrag,options);
      this.track.addEventListener('pointercancel',endDrag,options);
      this.track.addEventListener('lostpointercapture',endDrag,options);
      this.track.addEventListener('pointerleave',event=>{if(this.drag&&!this.drag.moved)endDrag(event);},options);
      this.track.addEventListener('dragstart',event=>event.preventDefault(),options);
      this.track.addEventListener('click',event=>{
        if(this.wasDragged){event.preventDefault();event.stopPropagation();}
      },{capture:true,...options});
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track)return;
        const card=this.track.querySelector('.amcart-card:not([hidden])');
        const step=card?card.getBoundingClientRect().width+8:160;
        let left;
        if(event.key==='ArrowRight')left=this.track.scrollLeft+step;
        if(event.key==='ArrowLeft')left=this.track.scrollLeft-step;
        if(event.key==='Home')left=0;
        if(event.key==='End')left=this.track.scrollWidth;
        if(left===undefined)return;
        event.preventDefault();
        this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      },options);
      document.addEventListener('theme:cart:change', this.onChange);
      document.addEventListener('theme:cart-drawer:open', this.onChange);
      this.filter();
      if (this.closest('[data-cart-page]')) this.refresh();
    }
    ids() { return [...document.querySelectorAll('[data-amelia-product-id]')].map(el => el.dataset.ameliaProductId); }
    filter() {
      const ids = this.ids();
      this.track.querySelectorAll('[data-amcart-product]').forEach(el => {el.hidden = ids.includes(el.dataset.amcartProduct);});
      this.hidden = !this.track.querySelector('.amcart-card:not([hidden])');
    }
    async refresh() {
      const id = this.ids()[0];
      this.filter();
      if (!id || this.currentId === id) return;
      this.currentId = id;
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        let html = this.cache.get(id);
        if (html === undefined) {
          const url = new URL(this.dataset.recommendationsUrl, location.origin);
          url.searchParams.set('section_id','amelia-cart-recommendations');
          url.searchParams.set('product_id',id);
          url.searchParams.set('limit','10');
          url.searchParams.set('intent','related');
          const response = await fetch(url, {signal:this.controller.signal});
          if (!response.ok) throw new Error('Recommendations unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          html = doc.querySelector('[data-amcart-results]')?.innerHTML || '';
          this.cache.set(id,html);
        }
        if (this.currentId !== id || !this.isConnected) return;
        this.track.innerHTML = html.trim() || this.fallback;
        this.track.scrollLeft = 0;
        this.filter();
        if (this.hidden) {this.track.innerHTML = this.fallback; this.filter();}
      } catch (error) {
        if (error.name !== 'AbortError') {this.currentId = null; this.track.innerHTML = this.fallback; this.filter();}
      }
    }
    disconnectedCallback() {
      this.controller?.abort(); this.events?.abort(); clearTimeout(this.dragTimer);
      document.removeEventListener('theme:cart:change',this.onChange);
      document.removeEventListener('theme:cart-drawer:open',this.onChange);
    }
  }
  customElements.define('amelia-cart-recommendations',AmeliaCartRecommendations);
})();
